import { sdk } from '@/lib/api/sdk-instance.js';

export class PatchNotesIntegration {
    async list() {
        return sdk.get('/patch-notes');
    }
}
